import { MessageCircle } from "lucide-react";
import { useSettings, waLink } from "@/context/SettingsContext";

export const WhatsAppButton = () => {
  const s = useSettings();
  return (
    <a
      href={waLink(s.whatsapp, "Hola, necesito ayuda con Impulso Visual.")}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-5 right-5 z-40 group flex items-center gap-3"
    >
      <span className="hidden sm:block bg-slate-900 text-white text-sm font-medium px-4 py-2 rounded-full soft-shadow opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-all duration-300">
        ¿Necesitás ayuda?
      </span>
      <span className="h-14 w-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-xl shadow-emerald-500/30 active:scale-90 transition-transform">
        <MessageCircle className="h-7 w-7 text-white" fill="white" />
      </span>
    </a>
  );
};
